"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCoverSurface = void 0;
const typeguard_1 = require("../types/typeguard");
const PageCount_1 = require("./PageCount");
const Spine_1 = require("./Spine");
const coverSurfaceRuleSet = {
  id: typeguard_1.isString,
  pageCount: PageCount_1.isPageCount,
  spine: Spine_1.isSpine
};
const isCoverSurface = cs => (0, typeguard_1.isType)(cs, coverSurfaceRuleSet);
exports.isCoverSurface = isCoverSurface;